import { render, staticRenderFns } from "./addressChange.vue?vue&type=template&id=ae9051c6&scoped=true"
import script from "./addressChange.vue?vue&type=script&lang=js"
export * from "./addressChange.vue?vue&type=script&lang=js"
import style0 from "./addressChange.vue?vue&type=style&index=0&id=ae9051c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9051c6",
  null
  
)

export default component.exports